import * as React from "react"
import {Box, Divider} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import {productsMatcherImageSize} from "../../@signals";


export default function ProductsMatcherTargetActionsZoom() {
	return <Box sx={{ display: 'flex', gap: 2 }}>
		<ButtonIconSeeker
			disabled={productsMatcherImageSize.value === 0}
			icon="magnifying-glass-minus"
			onClick={() => productsMatcherImageSize.value -= 1}
			tooltip="zoom -"
		/>

		<ButtonIconSeeker
			disabled={productsMatcherImageSize.value === 2}
			icon="magnifying-glass-plus"
			onClick={() => productsMatcherImageSize.value += 1}
			tooltip="zoom +"
		/>

		<Divider orientation="vertical" flexItem />
	</Box>
}